import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import PropTypes from 'prop-types';


import {List, ListItem, makeSelectable} from 'material-ui/List';
import {connect} from 'react-redux'
import {translate} from "react-i18next";

let SelectableList = makeSelectable(List);

function wrapState(ComposedComponent) {
    return class SelectableList extends Component {
        static propTypes = {
            children: PropTypes.node.isRequired,
            defaultValue: PropTypes.number.isRequired,
        };

        componentWillMount() {
            this.setState({
                selectedIndex: this.props.defaultValue,
            });
        }

        handleRequestChange = (event, index) => {
            this.setState({
                selectedIndex: index,
            });
        };

        render() {
            return (
                <ComposedComponent
                    value={this.state.selectedIndex}
                    onChange={this.handleRequestChange}
                >
                    {this.props.children}
                </ComposedComponent>
            );
        }
    };
}

SelectableList = wrapState(SelectableList);


class Menu extends Component {

    renderMenuItem = (text, url) => {
        return <ListItem onClick={this.props.handleClose} value={url} containerElement={<Link to={url}/>} primaryText={text}/>
    };


    render() {
        return <SelectableList defaultValue={this.props.location.pathname}>
            {this.renderMenuItem(this.props.t('drawer_learning'), '/learning/')}
            {this.renderMenuItem(this.props.t('drawer_package_management'), '/')}
            {/*{this.renderMenuItem("blabla", '/bla/')}*/}
        </SelectableList>
    }
}

const mapStateToProps = (state) => ({
    'location': state.router.location
});

export default connect(mapStateToProps)(translate()(Menu))


// WEBPACK FOOTER //
// ./src/components/Menu.js